import { render, staticRenderFns } from "./TaskDataPointItem.vue?vue&type=template&id=31e45591&scoped=true&"
import script from "./TaskDataPointItem.vue?vue&type=script&lang=ts&"
export * from "./TaskDataPointItem.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDataPointItem.vue?vue&type=style&index=0&id=31e45591&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e45591",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e45591')) {
      api.createRecord('31e45591', component.options)
    } else {
      api.reload('31e45591', component.options)
    }
    module.hot.accept("./TaskDataPointItem.vue?vue&type=template&id=31e45591&scoped=true&", function () {
      api.rerender('31e45591', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/TaskDataPointItem.vue"
export default component.exports